// ChoiceMessageEventHandler.ts
export function ChoiceMessageEventHandler(event: MessageEvent<any>)
{
    routeMessage(event);
}

export function ChoiceLogoutMessageEventHandler(event: MessageEvent<any>)
{
    if ("Logout" === event.data.action)
        routeMessage(event);
}

// A mapping between messages and handler functions
const eventHandlerMap : Record<string, Function> = 
{
    "Logout": (_eventData:any) => window.close(),
};

// Route the message to the correct handler
function routeMessage(event: MessageEvent<any>)
{
    const func = eventHandlerMap[event.data.action];
    if (!func)
    {
        console.log(`No message handler: ${event.data.action}`);
        return;
    }
    func(event.data);
}

